// @ts-nocheck
import { useState, useLayoutEffect, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import jwt_decode from 'jwt-decode';

import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function TopSubSidebar() {
  const [data, setData] = useState();
  const [active, setActive] = useState(false);
  const [shouldShow, setShouldShow] = useState(true);
  const [cookies, setCookie, removeCookie] = useCookies(['sessionToken']);

  //テスト環境
  const baseUrl = process.env.REACT_APP_PUBLIC_URL || '';

  const [clickedToday, setClickedToday] = useState(false);

  useEffect(() => {
    const key = 'seatButtonClickedDate';
    const today = new Date().toISOString().split('T')[0]; // "2025-05-21" の形式
    const savedDate = localStorage.getItem(key);

    if (savedDate === today) {
      setClickedToday(true);
    }
  }, []);

  // 座席ボタン状態を毎時チェック（1時間ごと）
  useEffect(() => {
    const checkDate = () => {
      const today = new Date().toISOString().split('T')[0];
      const savedDate = localStorage.getItem('seatButtonClickedDate');
      setClickedToday(savedDate === today);
    };

    // 初回実行（マウント直後）
    checkDate();

    // 毎時チェック（1時間 = 3600000ミリ秒）
    const interval = setInterval(() => {
      checkDate();
    }, 60 * 60 * 1000);

    // アンマウント時にインターバル破棄
    return () => clearInterval(interval);
  }, []);


  const handleSeatButtonClick = () => {
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem('seatButtonClickedDate', today);
    setClickedToday(true);
  };

  useEffect(() => {
    fetch(process.env.REACT_APP_SITE_URL)
      .then((json) => setData(json.url))
      .catch(() => console.log('error'));

    // sidebarState がない場合（初回）はローカルストレージにセット ※デフォルトはサイドバー表示
    if (localStorage.getItem('sidebarState') === null) {
      localStorage.setItem('sidebarState', 'opened')
    }

    // 開いたページの項目に背景色を付けるための処理
    settingIsActive();
  }, []);

  useLayoutEffect(() => {
    // if (cookies.sessionToken) {
    //   const decoded = jwt_decode<{ [name: string]: string }>(cookies.sessionToken);
    //   let email = decoded.data.EMAIL;
    //   email = email.replace("@zenken.co.jp", "");
    //   setMyEmail(email);
    // }

    // ビル内所属かどうかは、ログイン状態と同じ sessionToken から判定する
    // （buildingSlug の Cookie はブラウザ終了で消えるが sessionToken は10時間残るため、
    //   Cookie で判定するとログイン中なのに座席表バナーが消えることがある）
    let buildingSlug;
    if (cookies.sessionToken) {
      try {
        buildingSlug = jwt_decode<{ [name: string]: any }>(cookies.sessionToken).data.BUILDING_SLUG;
      } catch (e) {
        buildingSlug = undefined;
      }
    }

    if (buildingSlug !== "inBuilding") {
      setShouldShow(false);
    }

  }, []);

  function Openmenu() {
    let el = document.getElementById('sidebar__bar');
    let arrow = document.querySelector('.sidebar__bar--arrow');
    let acc = document.getElementById('accordion');
    el.classList.toggle('sidebarIs-open');
    arrow.classList.toggle('sidebarIs-open');
    if (el.classList.contains('sidebarIs-open')) {
      acc.style.transform = 'translateX(0)';
    } else {
      acc.style.transform = 'translateX(-146px)';
    }

    // ページ遷移後も表示・非表示を保持するための処理
    if (localStorage.getItem('sidebarState') === 'opened') {
      localStorage.setItem('sidebarState', 'closed')
    } else {
      localStorage.setItem('sidebarState', 'opened')
    }
  }

  function Search() {
    const baseUrl = 'https://secure.okbiz.jp/zenken/category/search?keyword=';
    let target = document.getElementById('header-search-form').value;
    window.open(baseUrl + target);
  }

  function SearchClick(e) {
    if (e.keyCode === 13) {
      const baseUrl = 'https://secure.okbiz.jp/zenken/category/search?keyword=';
      let target = document.getElementById('header-search-form').value;
      window.open(baseUrl + target);
    } else {
      return;
    }
  }

  /**
   * 開いたページの項目に背景色を付けるための処理
   */
  function settingIsActive() {
    const elements = document.getElementsByClassName('sidebar__link')
    // console.log('elements: ', elements);
    const currentUrl = window.location.pathname;
    // console.log('currentUrl: ', currentUrl)
    for (let i = 0, len = elements.length; i < len; i++) {
      const element = elements[i];
      // console.log('element: ', element)
      const href = element.getAttribute('href');
      // console.log('href: ', href);
      if (currentUrl === href) {
        element.classList.add('is-active');
        break;
      }
    }
  }


  return (
    <>
      <div
        className='sidebar side-accordion sub'
      >
        <div className='sidebar__content'>
          <div className='sidebar__purpose'>
            {shouldShow && (
              <div className='sidebar__list-wrap'>
                <div className='sidebar__list'>
                  <a target='_blank' href="https://script.google.com/a/macros/zenken.co.jp/s/AKfycbw5x8xcBsCA16hS9SOeBvjvpM8f4LE9vWBzThmw5XCHkvf8gREQold_51Yh-cCrL9Bm6Q/exec" className={`btn main-btn page-board-voice ${clickedToday ? 'clicked' : 'blink'}`} onClick={handleSeatButtonClick}>        {!clickedToday && (
                    <p className='zaseki-txt'>
                      <span>本日の座席を<br />登録してください</span>
                    </p>
                  )}<p className='zaseki-main-txt'>座席表</p></a>
                </div>
                <div className='zaseki-setting-link'>
                  <a href="https://www.ztree.cfbx.jp/info-wp/wp-content/uploads/2025/05/座席管理システム-初回アクセス時のマニュアル.pdf" target="_blank" rel="noopener noreferrer" className="text-link type-external">座席表の初回設定</a>
                </div>
              </div>
            )}
            <div className="service-area">
              <a className="service-banner sub" href="https://twitter.com/zenken_IR" target="_blank">
                <img
                  className=""
                  src={process.env.PUBLIC_URL + '/zenkenir.png'}
                />
              </a>
              <a className="service-banner sub" href="https://www.ztree.cfbx.jp/info-wp/wp-content/uploads/2026/02/【全社共有用】2026年度Zenken年間カレンダー_260227時点.pdf" target="_blank">
                <img
                  className=""
                  src={process.env.PUBLIC_URL + '/zenkencarendar.png'}
                />
              </a>
              <a className="service-banner sub" href="https://www.zenken.co.jp/our-goal/credo/" target="_blank">
                <img
                  className=""
                  src={process.env.PUBLIC_URL + '/zenkencredo.png'}
                />
              </a>
              {shouldShow && (
                <a className="service-banner sub" href="https://maps.app.goo.gl/be3PuU9JsQxfFKxY9" target="_blank">
                  <img
                    className=""
                    src={process.env.PUBLIC_URL + '/zenkenlunch.png'}
                  />
                </a>
              )}
            </div>
            {/* Z-BOSS */}
            {/* <div className="z-boss-container">
              <div className="z-boss-header">
                <div className="z-boss-icon">
                  <img src="./z_boss.png" alt="" />
                </div>
                <p className="z-boss-text">
                  迷ったらZ-BOSS！
                </p>
              </div>

              <div className="header-search-box z-boss-search">
                <input
                  type="text"
                  className="form-control"
                  id="header-search-form"
                  placeholder="Z-BOSSで検索"
                  onKeyUp={SearchClick}
                />
                <OverlayTrigger overlay={<Tooltip id={`header-search`}>検索する</Tooltip>}>
                  <Button
                    className="header-search-botton"
                    type="button"
                    id="header-search-button"
                    onClick={Search}
                  >
                    <img
                      src="/search_icon_blue.svg"
                      alt="検索する"
                      className="notice-bell"
                    />
                  </Button>
                </OverlayTrigger>
              </div>
            </div> */}


          </div>
        </div>
      </div >
    </>
  );
}
export default TopSubSidebar;
